import type {Dispatch} from 'react';
import { createContext} from 'react';
import type {Moment} from 'moment';

import type {CleverSyncResults} from './util';

export interface CleverSyncState {
  loading: boolean;
  syncResults?: CleverSyncResults;
  lastSyncDate?: Moment;
  isModalOpen?: boolean;
  currentlyInProgressSyncId?: string;
  userCleverDistrictId?: string;
  userCleverId?: string;
  isLogoutModalOpen?: boolean;
}

export type CleverSyncAction =
  | {type: 'openModal'}
  | {type: 'closeModal'}
  | {type: 'openLogoutModal'}
  | {type: 'closeLogoutModal'}
  | {type: 'setSyncDate'; date: Moment}
  | {type: 'setSyncResults'; syncResults: CleverSyncResults}
  | {type: 'setLoading'; value: boolean}
  | {type: 'setCurrentlyInProgressSyncId'; value?: string};

export const CleverSyncReducer = (
  state: CleverSyncState,
  action: CleverSyncAction
): CleverSyncState => {
  switch (action.type) {
    case 'closeModal':
      return {...state, isModalOpen: false, syncResults: undefined};

    case 'openModal':
      return {...state, isModalOpen: true};
    case 'openLogoutModal':
      return {...state, isLogoutModalOpen: true};
    case 'closeLogoutModal':
      return {...state, isLogoutModalOpen: false};
    case 'setSyncDate':
      return {...state, lastSyncDate: action.date};
    case 'setSyncResults':
      return {...state, syncResults: action.syncResults};
    case 'setLoading':
      return {...state, loading: action.value};
    case 'setCurrentlyInProgressSyncId':
      return {...state, currentlyInProgressSyncId: action.value};
    default:
      return state;
  }
};

export const CleverSyncContext = createContext({
  loading: false
} as CleverSyncState);
export const CleverSyncDispatch = createContext({} as Dispatch<CleverSyncAction>);
